import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/shell/App';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root is missing from index.html.');
}

/**
 * The pre-mount fallback goes when the app is about to draw (DEP-03).
 *
 * Removed here rather than hidden with CSS: a fallback nobody removes is a fallback that ships on
 * every screen, and one hidden by a stylesheet is still read by a screen reader.
 */
document.getElementById('boot-fallback')?.remove();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
